var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickdet04(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6613 8.33067C16.6613 12.4902 12.047 16.8221 10.4975 18.16C10.3531 18.2686 10.1774 18.3273 9.99681 18.3273C9.8162 18.3273 9.64049 18.2686 9.49614 18.16C7.94663 16.8221 3.33228 12.4902 3.33228 8.33067C3.33228 6.56313 4.03443 4.86798 5.28427 3.61813C6.53411 2.36829 8.22926 1.66614 9.99681 1.66614C11.7644 1.66614 13.4595 2.36829 14.7093 3.61813C15.9592 4.86798 16.6613 6.56313 16.6613 8.33067Z",
    stroke: "#F0E1CE",
    strokeOpacity: 0.7,
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99676 10.8299C11.377 10.8299 12.496 9.71095 12.496 8.33068C12.496 6.95041 11.377 5.83148 9.99676 5.83148C8.61649 5.83148 7.49756 6.95041 7.49756 8.33068C7.49756 9.71095 8.61649 10.8299 9.99676 10.8299Z",
    stroke: "#F0E1CE",
    strokeOpacity: 0.7,
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickdet04);
export default __webpack_public_path__ + "static/media/tickdet04.c5041796ab6040358dce066295e3863e.svg";
export { ForwardRef as ReactComponent };